import React from 'react';
import { MenuItem } from '@material-ui/core';
import { useTranslation } from 'react-i18next';

import Select from 'components/@common/Inputs/Select';
import { WdtCharacterGroup } from 'types/schema-generated-types';

interface CharacterGroupPickerProps {
  groups: WdtCharacterGroup[];
  value?: number;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

const CharacterGroupPicker: React.FC<CharacterGroupPickerProps> = ({ groups, value, onChange }) => {
  const { t } = useTranslation('Reports');
  return (
    <Select
      placeholder={t('Select a Character Group')}
      value={value}
      size="small"
      name="characterGroup"
      inputProps={{
        'aria-label': t('Select the Character Group')
      }}
      onChange={onChange}
    >
      <MenuItem value="">{t('All')}</MenuItem>
      {groups &&
        groups.map(option => (
          <MenuItem key={`${option.id}-character-group-option`} value={option.id}>
            {option.name}
          </MenuItem>
        ))}
    </Select>
  );
};

export default CharacterGroupPicker;
